import { createSlice } from "@reduxjs/toolkit";

import { AuthState } from "@/types/auth";

const initialState: AuthState = {
  loading: true,
  error: null,
  user: null,
  logged: false,
  greetingModal: false,
  snackBarMsj: {
    state: false,
    msj: "",
    type: undefined,
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    fetchStarted: (state) => {
      state.loading = true;
    },
    fetchFailed: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    fetchSucceded: (state, action) => {
      state.user = action.payload;
      state.logged = true;
      state.loading = false;
    },
    setLoggedSucceded: (state, action) => {
      state.logged = action.payload;
      state.loading = false;
    },
    setSnackBarMsjSucceded: (state, action) => {
      state.snackBarMsj = action.payload;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    removeUser: (state) => {
      state.user = null;
    },
    setGreetingModal: (state, action) => {
      state.greetingModal = action.payload;
    },
  },
});

export default authSlice.reducer;
